<template>
  <li
    class="
      p-4
      mb-3
      flex
      justify-between
      items-center
      border border-light-grey
      rounded-lg
    "
    style="background-color: #f8fafb"
  >
    <div class="flex items-center">
      <feather-icon
        :icon="iconMap[question.type]"
        svgClasses="h-4 w-4"
        class="
          p-2
          inline-flex
          rounded-md
          bg-white
          border border-light-grey
          shadow
        "
      ></feather-icon>
      <div>
        <p class="ml-4 text-gray-700 font-semibold font-sans tracking-wide">
          {{ question.title }}
        </p>

        <vs-row v-if="question.type === 'rating'" class="ml-4 mt-2">
          <div
            v-for="iter in [1, 2, 3, 4, 5]"
            :key="iter"
            class="
              text-center
              justify-center
              rounded-full
              flex
              items-center
              mr-1
              rating-option
            "
            :style="{
              'background-color':
                iter === question.answer ? '#E6BD71' : '#F4E8D3',
            }"
          >
            {{ iter }}
          </div>
        </vs-row>
        <p
          v-if="question.type === 'rating' && question.comment"
          class="ml-4 mt-1 text-gray-600 font-sans tracking-wide text-sm italic"
        >
          {{ question.comment }}
        </p>

        <vs-chip
          class="ml-4 mt-2"
          v-else-if="
            question.type === 'yesNoCritical' && question.answer === 'No'
          "
          color="danger"
          >No. (Notification sent)</vs-chip
        >
        <p v-else class="ml-4 text-gray-600 font-sans tracking-wide">
          {{ question.stringAnswer }}
        </p>
        <!-- 
        <img
          class="ml-4 mt-2 mb-2 rounded-lg shadow"
          v-if="question.type === 'photoUpload' && question.isAnswered"
          :src="question.answer"
          width="320"
          height="240"
          v-img:photoAnswers
        /> -->
        <!--         <vs-images
          hover="zoom"
          v-if="question.type === 'photoMultipleUpload' && question.isAnswered"
        >
          <vs-image
            class="ml-4 mt-2 mb-2 rounded-lg shadow"
            v-for="answer in question.answer"
            :key="answer"
            :src="answer"
            width="320"
            height="240"
          />
        </vs-images> -->

        <vs-row
          class="ml-3 mt-1"
          v-if="question.type === 'photoMultipleUpload' && question.isAnswered"
        >
          <vs-col
            vs-w="3"
            class="mr-2 mb-2"
            v-for="(answer, index) in question.answer"
            :key="index"
          >
            <img
              class="image-item rounded-lg shadow"
              v-img:todoImages
              :src="answer"
            />
          </vs-col>
        </vs-row>

        <!--         <div
          class="flex justify-start"
          v-if="question.type === 'photoMultipleUpload' && question.isAnswered"
        >
          <img
            class="ml-4 mt-2 mb-2 rounded-lg shadow"
            v-for="(answer, index) in question.answer"
            :key="index"
            :src="answer"
            style="width: 320px; height: 240px"
            width="320"
            height="240"
            v-img:photoAnswers
          />
        </div> -->

        <!--         <video
          class="ml-4 mt-2 mb-2 rounded-lg shadow"
          v-if="question.type === 'videoUpload' && question.isAnswered"
          width="320"
          height="240"
          controls
        >
          <source :src="question.answer" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
 -->
        <div
          class="flex justify-start"
          v-if="question.type === 'videoMultipleUpload' && question.isAnswered"
        >
          <video
            class="ml-4 mt-2 mb-2 rounded-lg shadow"
            v-for="(answer, index) in question.answer"
            :key="index"
            :src="answer"
            width="320"
            height="240"
            controls
          >
            <source :src="answer" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>

    <div class="flex" v-if="question.category !== 'None'">
      <p class="ml-4 text-gray-500 font-sans tracking-wide">
        {{ question.category }}
      </p>
    </div>
  </li>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      iconMap: {
        yesNo: "CheckSquareIcon",
        yesNoCritical: "AlertOctagonIcon",
        text: "TypeIcon",
        number: "DollarSignIcon",
        rating: "StarIcon",
        photoUpload: "CameraIcon",
        videoUpload: "VideoIcon",
        photoMultipleUpload: "CameraIcon",
        videoMultipleUpload: "VideoIcon",
      },
    };
  },
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>


<style scoped lang="css" src="@/assets/css/tailwind.min.css"></style>
<style scoped lang="scss">
.image-item {
  width:100%;
  height:auto;
  object-fit: cover;
  border-radius: 7px;
}
.rating-option {
  width: 28px !important;
  height: 28px !important;
  padding: 7px;
  color: white;
  font-size: 0.9rem;
  border-radius: 50%;
}
</style>

